"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalLoadingBar = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const hooks_1 = require("../hooks");
const VerticalLoadingBar = ({ disabled, percent, containerProps, }) => {
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    return (react_2.default.createElement(react_1.Flex, Object.assign({ bgColor: "rgba(0, 255, 84, 0.15)", flex: 1, justifyContent: "flex-end", direction: "column", _notLast: { marginRight: '8px' } }, containerProps),
        react_2.default.createElement(react_1.Box, { bgColor: primaryColor, width: "full", transition: "height 0.5s", height: disabled ? 0 : `${percent}%` })));
};
exports.VerticalLoadingBar = VerticalLoadingBar;
//# sourceMappingURL=VerticalLoadingBar.js.map